/**
 * Contract Generation Service
 * Handles contract generation API calls
 */

import { apiClient } from './api.client';
import { RecordDealGeneration, GetGenerationsParams, Agreement } from '../types/api.types';

/**
 * Generate a record deal agreement
 * Returns the generated markdown content as a downloadable file
 */
export const generateRecordDeal = async (agreement: Agreement): Promise<string> => {
  return apiClient.post<string>('/api/write/record-deal', agreement);
};

/**
 * Store a generated record deal in the database
 */
export const storeRecordDeal = async (
  agreement: Agreement,
  generatedContent: string
): Promise<RecordDealGeneration> => {
  return apiClient.post<RecordDealGeneration>('/api/write/record-deal/store', {
    agreement,
    generatedContent,
  });
};

/**
 * Get user's record deal generations
 */
export const getUserGenerations = async (params: GetGenerationsParams = {}): Promise<RecordDealGeneration[]> => {
  const queryParams = new URLSearchParams();
  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }
  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset.toString());
  }

  const endpoint = `/api/write/record-deal-generations${queryParams.toString() ? `?${queryParams}` : ''}`;
  return apiClient.get<RecordDealGeneration[]>(endpoint);
};

/**
 * Get a specific record deal generation by ID
 */
export const getGenerationById = async (id: string): Promise<RecordDealGeneration> => {
  return apiClient.get<RecordDealGeneration>(`/api/write/record-deal-generations/${id}`);
};

/**
 * Get a record deal generation as HTML
 * Returns the HTML content for display or PDF generation
 */
export const getGenerationAsHtml = async (id: string): Promise<string> => {
  return apiClient.get<string>(`/api/write/record-deal-generations/${id}/html`);
};

/**
 * Delete a record deal generation
 */
export const deleteGeneration = async (id: string): Promise<void> => {
  return apiClient.delete<void>(`/api/write/record-deal-generations/${id}`);
};
 